var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagDjibouti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.609 17.3913C14.609 17.3913 4.6959 4.68406 4.68652 4.68631C7.5819 1.79088 11.582 0 16.0003 0C24.8368 0 32.0003 7.1635 32.0003 16L14.609 17.3913Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.609 16C14.609 16 4.6959 27.3159 4.68652 27.3137C7.5819 30.2091 11.582 32 16.0003 32C24.8368 32 32.0003 24.8365 32.0003 16H14.609Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68625 4.68628C-1.56212 10.9347 -1.56212 21.0653 4.68625 27.3138C7.26831 24.7317 9.75163 22.2484 16 16L4.68625 4.68628Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47562 11.8262L7.51156 15.0147H10.8644L8.15206 16.9854L9.18794 20.174L6.47562 18.2034L3.76319 20.174L4.79931 16.9854L2.08694 15.0147H5.43956L6.47562 11.8262Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagDjibouti);
export default __webpack_public_path__ + "static/media/flag_djibouti.2e8d11b2058b76d3a0b4c925fc8c4a85.svg";
export { ForwardRef as ReactComponent };